export const StripePublicKey = process.env.REACT_APP_STRIPE_PUBLIC_KEY || "";
